export default function (config) {
    'ngInject';

    return {
        restrict: 'E', // Only element name can be used for directive definition
        scope: {
            directiveTickerText: '@'
        },
        // TODO: Remove internal links from js files and use only phalcon's `url` function for
        // link generation, where we put router name and params for the router
        templateUrl: `${config.get('assetsURL')}views/ticker.html`,
        controller: 'directiveTickerCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/ticker.js